var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.layout,{tag:"component"}),_c('router-view'),(_vm.$root.loading)?_c('loading'):_vm._e(),_c(_vm.footer,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }